import _asyncToGenerator from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _regeneratorRuntime from "/codebuild/output/src3842342609/src/proteket-gatsby/node_modules/@babel/runtime/regenerator/index.js";
import { ConsoleLogger } from '@aws-amplify/core';
import { assertIdentityPoolIdConfig } from '@aws-amplify/core/internals/utils';
import { getAuthStorageKeys } from '../tokenProvider/TokenStore.mjs';
import { IdentityIdStorageKeys } from './types.mjs'; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var logger = new ConsoleLogger('DefaultIdentityIdStore');

var DefaultIdentityIdStore = /*#__PURE__*/function () {
  function DefaultIdentityIdStore(keyValueStorage) {
    _classCallCheck(this, DefaultIdentityIdStore);

    this._authKeys = {};
    this.keyValueStorage = keyValueStorage;
  }

  _createClass(DefaultIdentityIdStore, [{
    key: "setAuthConfig",
    value: function setAuthConfig(authConfigParam) {
      assertIdentityPoolIdConfig(authConfigParam.Cognito);
      this.authConfig = authConfigParam;
      this._authKeys = createKeysForAuthStorage('Cognito', authConfigParam.Cognito.identityPoolId);
    }
  }, {
    key: "loadIdentityId",
    value: function () {
      var _loadIdentityId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$authConfig;

        var storedIdentityId;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                assertIdentityPoolIdConfig((_this$authConfig = this.authConfig) === null || _this$authConfig === void 0 ? void 0 : _this$authConfig.Cognito);
                _context.prev = 1;

                if (!this._primaryIdentityId) {
                  _context.next = 6;
                  break;
                }

                return _context.abrupt("return", {
                  id: this._primaryIdentityId,
                  type: 'primary'
                });

              case 6:
                _context.next = 8;
                return this.keyValueStorage.getItem(this._authKeys.identityId);

              case 8:
                storedIdentityId = _context.sent;

                if (!storedIdentityId) {
                  _context.next = 11;
                  break;
                }

                return _context.abrupt("return", {
                  id: storedIdentityId,
                  type: 'guest'
                });

              case 11:
                return _context.abrupt("return", null);

              case 12:
                _context.next = 18;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](1);
                logger.log('Error getting stored IdentityId.', _context.t0);
                return _context.abrupt("return", null);

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[1, 14]]);
      }));

      function loadIdentityId() {
        return _loadIdentityId.apply(this, arguments);
      }

      return loadIdentityId;
    }()
  }, {
    key: "storeIdentityId",
    value: function () {
      var _storeIdentityId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(identity) {
        var _this$authConfig2;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                assertIdentityPoolIdConfig((_this$authConfig2 = this.authConfig) === null || _this$authConfig2 === void 0 ? void 0 : _this$authConfig2.Cognito);

                if (identity.type === 'guest') {
                  this.keyValueStorage.setItem(this._authKeys.identityId, identity.id); // Clear in-memory storage of primary identityId

                  this._primaryIdentityId = undefined;
                } else {
                  this._primaryIdentityId = identity.id; // Clear locally stored guest id

                  this.keyValueStorage.removeItem(this._authKeys.identityId);
                }

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function storeIdentityId(_x) {
        return _storeIdentityId.apply(this, arguments);
      }

      return storeIdentityId;
    }()
  }, {
    key: "clearIdentityId",
    value: function () {
      var _clearIdentityId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this._primaryIdentityId = undefined;
                _context3.next = 3;
                return this.keyValueStorage.removeItem(this._authKeys.identityId);

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function clearIdentityId() {
        return _clearIdentityId.apply(this, arguments);
      }

      return clearIdentityId;
    }()
  }]);

  return DefaultIdentityIdStore;
}();

var createKeysForAuthStorage = function createKeysForAuthStorage(provider, identifier) {
  return getAuthStorageKeys(IdentityIdStorageKeys)("com.amplify.".concat(provider), identifier);
};

export { DefaultIdentityIdStore };